import { isError } from 'lodash';
import { assign } from 'xstate';
import { config } from '~/funnels/perch-energy/config';
import { SolarFunnelContext } from '~/machines/solar-funnel/types';
import { LDClient } from '~/providers/launch-darkly';
import { LDFlags } from '~/providers/launch-darkly/flags';
import { getEnrollmentOptions } from '~/utils/get-enrollment-options';
import { store } from '~/utils/store';
import { sendToSegment } from '~/utils/tracking';
import { PerchEnergyContext } from './types';

export const perchMachineActions = {
  setFunnelId: assign<PerchEnergyContext, any>((_context, _event) => ({
    funnelId: config.id,
  })),
  setFunnelPacket: assign((_context, event: any) => {
    return {
      funnelPacket: event.data.funnelPacket,
      utmParams: event.data.utmParams,
    };
  }),
  setEnrollmentSelection: assign((_context, event: any) => ({
    enrollmentSelection: event.data.enrollmentSelection,
  })),
  setEnrollmentOptions: assign((_context: SolarFunnelContext) => {
    const enrollmentOptions = getEnrollmentOptions({
      preference: _context.queryParams.preferredEnrollment,
      limit: LDClient.variation(LDFlags.showFallbackButton) ? undefined : 1,
      funnelId: config.id,
      utilityId: _context.funnelPacket!.utility.id,
    });
    return enrollmentOptions;
  }),
  setUtilityConnectStatus: assign((_context, event: any) => ({
    utilityConnectStatus: event?.data?.utilityConnectStatus!,
  })),
  trackFunnelCompleted: (context: PerchEnergyContext, _event) => {
    sendToSegment({
      type: 'funnel_completed',
      funnelPacket: context.funnelPacket!,
      track: context.utilitySelection?.funnelTrack,
    });
  },
  trackCSUnavailable: (context: PerchEnergyContext) => {
    sendToSegment({
      type: 'cs_unavailable',
      funnelPacket: context.funnelPacket!,
    });
  },
  trackFetchFeatureFlagsError: (context, event: any) => {
    sendToSegment({
      type: 'track_ld_fetch_feature_flags_error',
      funnelTrack: context.utilitySelection?.funnelTrack,
      utilityId: context.utilitySelection?.id,
      errorClass: !!event.data && isError(event.data) ? event.data.name : 'LD_Down',
      errorMessage:
        !!event.data && isError(event.data)
          ? event.data.message
          : 'Something went wrong with LaunchDarkley',
    });
  },
  setUtilitySelection: assign<PerchEnergyContext, any>((_context, event) => ({
    utilitySelection: event.data.utility,
    zipCode: event.data.zipCode,
    forceWaitlist: false,
  })),
  clearUtilitySelection: assign<PerchEnergyContext, any>((_context, _event) => ({
    utilitySelection: undefined,
    zipCode: undefined,
  })),
  addUtilitySelectionToStore: (_context, event) =>
    store.set('UTILITY_SELECTION', event.data.utility),
  setFunnelVnmProjectId: assign((_context, event: any) => ({
    funnelVnmProjectId:
      event.data.funnelVnmProjectId ||
      LDClient.variation(LDFlags.ffDefaultSignupProjectId)?.project_id,
  })),
};
